export const home = {
  'Made for': 'Creato per',
};
